import { useContext, useEffect, useState, useMemo } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { axiosClient } from '../../../library/Service/axiosClient';
import moment from 'moment';

const ViewFileLogs = () => {
    const { state, dispatch } = useContext(SmartContext);

    const jobData = state?.modalData?.data;
    const showFlag = state?.modalFlags?.showSchoolTrackerFileLogs;

    const [activeMarkerTab, setActiveMarkerTab] = useState<'raw-data' | 'update-data'>('raw-data');
    const [logData, setLogData] = useState<any[]>([]);

    const instituteId = state?.data?.schoolCount?.[0]?.schoolId;

    useEffect(() => {
        if (!instituteId) return;

        const fetchLog = async () => {
            try {
                const response = await axiosClient().post(
                    `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/institute-tracker/getfilelogs-byfieldId`,
                     {
                        selectedQuarter: jobData.selectedQuarter,
                        instituteId
                    }
                );

                if (response?.status === 200) {
                    setLogData(response?.data || []);
                }
            } catch (error) {
                console.error('Error fetching logs:', error);
            }
        };

        fetchLog();
    }, [showFlag,instituteId]);

    const insertLogs = useMemo(
        () => logData.filter(log => log.type === 'insert'),
        [logData]
    );

    const updateLogs = useMemo(
        () => logData.filter(log => log.type === 'update'),
        [logData]
    );

    const renderTable = (data: any[],isRaw: boolean) => (
        <div className="table-responsive">
            <table className="table w-750" style={{ minWidth: '750px' }}>
                <thead>
                    <tr>
                        <th>File Name</th>
                        {/* <th>Source</th> */}
                        <th>Records</th>
                        <th>Date</th>
                        <th>By</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map(log => (
                            <tr key={log.id}>
                                <td>{log.fileName}</td>
                                {/* <td>{log.source}</td> */}
                                <td>{!isRaw ? log.totalRecords : log.rawRollNoCount}</td>
                                <td>{moment(log.createdAt).format('DD-MMM-YYYY h:mm A')}</td>
                                <td>{log.createdBy}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={5} className="text-center">
                                No records found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );

    return (
        <div
            className={`modal fade px-3 ${showFlag ? 'show' : ''}`}
            style={{ display: showFlag ? 'block' : 'none' }}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered max-900 mx-auto">
                <div className="modal-content radius-15">
                    <div className="modal-body p-4 p-md-5 position-relative">

                        <h5 className="font-32 font-600 mb-4">
                            File Logs
                        </h5>

                        <button
                            className="position-absolute top-20 right-20 text-secondary font-30 border-0 bg-transparent"
                            onClick={() =>
                                dispatch({
                                    type: 'TOGGLE_MODAL_VISIBILITY',
                                    payload: { modalName: 'showSchoolTrackerFileLogs' },
                                })
                            }
                        >
                            <i className="bi bi-x-circle-fill"></i>
                        </button>

                        <div className="fileLogs y-scroll">
                            <div className="block-custom-tab m-0">

                                {/* Tabs */}
                                <ul className="nav nav-pills mt-4 border-bottom">
                                    {/* <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeMarkerTab === 'raw-data' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => setActiveMarkerTab('raw-data')}
                                        >
                                            📥 Received Data Upload Log
                                        </button>
                                    </li> */}

                                    {/* <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeMarkerTab === 'update-data' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => setActiveMarkerTab('update-data')}
                                        >
                                            ✏️ Field Update Log
                                        </button>
                                    </li> */}
                                </ul>

                                <div className="mt-4 y-scroll" style={{ maxHeight: '400px' }}>
                                    {activeMarkerTab === 'raw-data' && renderTable(insertLogs,true)}
                                    {activeMarkerTab === 'update-data' && renderTable(updateLogs,false)}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewFileLogs;
